export const LABELS = {
  ORDER_SUMMARY: "Order Summary",
  ORDER_ID: "Order ID",
  CUSTOMER_NAME: "Customer Name",
  ORDER_DATE: "Order date",
  ORDER_TIME: "Order time",
  PAYMENT_MODE: "Payment Mode",
  SUBTOTAL: "Subtotal",
  RECEIVED_PRICE: "Received Price",
  REMAINING_PRICE: "Remaining Price",
  ORDER_STATUS: "Order Status",
  PAYMENT_METHODS: "Payment methods",
  PRINT_RECEIPT: "Print Receipt",
  CANCEL: "Cancel Order",
  CANCELED: "Cancelled",
};

export const STATUS_OPTIONS = ["Confirm", "Pending", "Delivered"];
export const PAYMENT_OPTIONS = ["Cash", "Card"];